import React, { useEffect, useState } from 'react';
import { addDivParam } from '../../../../common/utils/liveUtil';

export default function Tv24CurationNormalType3(props) {
  const [data, setData] = useState(null);

  useEffect(() => {
    setData(props.data);
  }, [props]);

  return (
    (data && <div className="contents_area_24tvType03">
      <section id={encodeURIComponent(data.title.trim())} style={{ scrollMarginTop: '180px' }}>
        <div className="module_titleline_w">
          <h3 className="module_titleline_title">
            <strong className="title_text">{data.title}</strong>
            <span className="sub_text">{data.subtitle}</span>
          </h3>
        </div>
        <div className="live_list_w">
          <ul className="live_list_inner">
            {data && data.items.filter(item => item.pc_service_yn === 'Y').map((item, index) => {
              let listType = index < 2 ? 'live_list_cont type_big' : 'live_list_cont';
              return (<li
                key={index}
                className={listType}>
                <div className="module_box_w_type2">
                  <a href={addDivParam(item.pc_link_url)} target={item.pc_link_target ? '_blank' : '_self'} className="mb_link">
                    <div className="mb_image_w">
                      <div className="mb_image_inner">
                        <img src={item.pc_program_img} className="mb_image" alt={item.pc_program_alt} />
                      </div>
                    </div>
                    <div className="mb_info_w">
                      <span className="mbif_channel">{item.title}</span>
                      <span className="mbif_subtitle">{item.pc_tags ? item.pc_tags : ''}</span>
                    </div>
                  </a>
                </div>
              </li>
              );
            })}
          </ul>
        </div>
      </section>
    </div>)
  );
}
